<template>
	<div id="corporateApply">
		<div class="container">


			<div class="companyInfoIpt">
				<!-- <div class="titleContainer">
					<div class="shu">
					</div>
					<div class="title">
						百万学生探岗报名
					</div>
				</div> -->
				<!-- <img src="../img/jobShadowing1.png" alt=""
					style="width: 700px;height: 150px;margin-bottom: 30px;cursor: pointer;"  /> -->
				<div class="bg" @click="openPDF">
					<div class="title" style="color: #fff;margin-left: -2px;">
						万企线上招聘会
					</div>
					<div class="subheading">
						<div class="" style="color: #fff;">
							活动介绍
						</div>
						<img src="../img/arrows.png" alt="" />
					</div>
				</div>

				<div class="title" style="font-weight: bold;font-size: 16px;color: #333333;margin-bottom: 20px;">
					报名参加
				</div>
				<div class="bg3" style="display: flex;align-items: center;flex-direction: initial;cursor: initial;">
					<div class="">
						<div class="" style="color: #06855d;font-size: 16px;font-weight: bold;margin-bottom: 10px;">
							完善企业主页
						</div>
						<div class="" style="color: #606266;font-size: 16px;font-weight: 500;">
							美化公司介绍，上传图片/宣传片，打造雇主品牌第一印象
						</div>
					</div>
					<div class=""
						style="border-radius: 40px;background: #059e6e;padding: 5px 10px;font-size: 14px;color: #fff;cursor: pointer;"
						@click="toCorporateImage">
						去完善
					</div>
				</div>

				<div class="bg2" style="display: flex;align-items: center;flex-direction: initial;cursor: initial;">
					<div class="">
						<div class="" style="color: #26abff;font-size: 16px;font-weight: bold;margin-bottom: 10px;">
							发布岗位
						</div>
						<div class="" style="color: #606266;font-size: 16px;font-weight: 500;">
							详细填写职位需求，确保推荐更精准
						</div>
					</div>
					<div class=""
						style="border-radius: 40px;background: #26abff;padding: 5px 10px;font-size: 14px;color: #fff;cursor: pointer;"
						@click="toPositionManagement">
						{{jobList.length>0?'已发布':'去发布'}}
					</div>
				</div>

				<div class="title" style="font-weight: bold;font-size: 16px;color: #333333;margin-bottom: 20px;">
					活动须知
				</div>

				<div class="bg1" style="display: flex;">
					<!-- <div class="">
						<div class="" style="color: #06855d;font-size: 16px;font-weight: bold;margin-bottom: 10px;">
							发布岗位
						</div>
						<div class="" style="color: #606266;font-size: 16px;font-weight: 500;">
							详细填写职位需求，确保推荐更精准
						</div>
					</div> -->
					<div class="" style="display: flex;align-items: flex-start;font-size: 0;">
						<img src="../img/corporateApply1.png" alt=""
							style="width: 20px;height: 20px;margin-right: 10px;margin-top: 3px;" />
						<div class="" style="color: #333;font-size: 16px;font-weight: 500;margin-bottom: 10px;">
							活动时间：2026年10月10日
						</div>
					</div>
					<div class="" style="display: flex;align-items:  flex-start;font-size: 0;">
						<img src="../img/corporateApply2.png" alt=""
							style="width: 20px;height: 20px;margin-right: 10px;margin-top: 3px;" />
						<div class="" style="color: #333;font-size: 16px;font-weight: 500;margin-bottom: 10px;">
							参与方式：活动前后学校将引导学生在线投递与咨询，请用人单位及时在中<span style="cursor: pointer;color: #06855d;"
								@click="toMessageManagement">【消息】</span>查看回复。
						</div>
					</div>
				</div>

				<div class="btnContainer">
					<!-- <i class="el-icon-delete" @click="cancel" v-if="isComplete" style="margin-right: 10px;cursor: pointer;"></i> -->
					<!-- <el-button type="danger" @click="cancel" v-if="isComplete" icon="el-icon-delete">
					</el-button> -->
					<el-button class="cancel"  v-if="isComplete" @click="cancel">取消</el-button>
					<el-button class="preview" type="primary" plain @click="preview" icon="el-icon-view" v-if="isComplete">预览线上会场</el-button>
					<el-button type="primary" @click="submit" v-if="!isComplete">立即报名</el-button>
					<el-button type="primary" @click="submit" v-else>修改报名</el-button>
				</div>
			</div>
		</div>


		<!-- <el-dialog :visible.sync="dialogVisible" :show-close='false' width="800px">
			<div class="elDialog">
				<img class="close" @click="closeElDialog" src="../img/close.png" alt="" />
				<div class="main">
					<div class="title">预览二维码</div>
					<div class="qrcodeContainer">
						<div class="qrcode">
							<div class="qrcodeImage">
								<img class="qrcodeImg" :src="xet_alive_code" alt="" />
								<img class="qrcodeLogo" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/02/logopt.png" alt="" />
							</div>
		
							<div class="hite1">
								扫描识别二维码
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog> -->

		<el-dialog :visible.sync="dialogVisible" :close-on-click-modal='false' :show-close='false' width="800px"
			class="elDialog">
			<div class="previewElDialog">
				<img class="close" @click="elDialogClose2" src="../img/close.png" alt="" />
				<div class="main">
					<div class="title">线上会场预览</div>
					<div class="qrcodeContainer">
						<div class="qrcode">
							<img :src="xet_alive_code" alt="" />
							<div class="hite1">
								扫描<span style="color:#0084FF;">识别二维码</span>
							</div>
							<div class="hite2">
								可在手机上预览效果
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>


	</div>
</template>
<script>
    const config = require('../../WebConfig')
	import {
		mapMutations,
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				applyData: null,
				dialogVisible: false,
				qrcodeImg: '',
				audit_status: 0,
				meeting_price: '',
				isComplete: false,
				xet_alive_code: '',
				jobList:[],
			};
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		mounted() {
			this.getMySchoolMeetingOne()
			this.getQrcode()
			
			
			if (sessionStorage.getItem('applyData')) {
				let applyData = JSON.parse(sessionStorage.getItem('applyData'))
				this.applyData = applyData
				let jobList = []
				if(applyData&&applyData.job_data){
					jobList = JSON.parse(applyData.job_data)
				}
				this.jobList = jobList
				// this.isComplete = this.applyData.isComplete
			}
		},
		methods: {
			...mapMutations(['setIslogin']),
			getQrcode(id, scope) {
				// &is_test=1
				this.$util.post(
					`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/courseware/meeting&id=${3584}&is_test=${config.IS_TEST}`, {
						// app_type: 10,
						// page_path: 'pages/recruit/jobdetail',
						// id:id
					},
					(res) => {
						if (res.code == 200) {
							this.xet_alive_code = res.data.qrCode

							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				)
			},
			preview() {
				this.$util.post('v2/school_job/regSchoolMeeting', {...this.applyData, meeting_id: 3584}, (res) => {
					if (res.code === 200) {
						// this.getCitysList()
						this.dialogVisible = true
						// this.dialogVisible = true
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			},
			toMessageManagement() {
				this.$router.push({
					path: '/messageManagement',
				})
			},
			cancel() {
				this.$confirm('您确定要取消报名吗?', '提示', {
						confirmButtonspan: '确定',
						cancelButtonspan: '取消',
						type: 'warning',
					})
					.then(() => {

						this.$util.post(
							`v2/school_job/cancelSchoolMeeting`, {
								admin_id: this.schoolInfo.admin_id,
								meeting_id: 3584,
							},
							(res) => {
								if (res.code == 200) {
									this.$message({
										message: '取消报名成功',
										type: 'success',
										duration: 1000
									})
									setTimeout(() => {
										let is_demo = sessionStorage.getItem('demo')
										if(is_demo){
											this.$router.push({
												path: '/meeting?demo='+is_demo,
											})
										}else{
											this.$router.push({
												path: '/meeting',
											})
										}
									}, 1000)

								}else{
										this.$message({
											message: res.msg,
											type: 'error',
										})
									}
							}
						)
					})
					.catch(() => {

					})
			},
			getMySchoolMeetingOne() {
				this.$util.post('v2/school_job/getRegMeetingDetail', {
					meeting_id: 3584,
					admin_id: this.schoolInfo.admin_id
				}, (res) => {
					if (res.code === 200) {
						if (res.data) {
							this.isComplete = true
							let obj = {
								admin_id: this.schoolInfo.admin_id,
								meeting_id: 3584,
								meeting_info_str: '',
								meeting_info: res.data.meeting_info,
								adv_num: 0,
								job_data: res.data.job_data
							}
							if(res.data.job_data&&res.data.job_data!=''){
								this.jobList = JSON.parse(res.data.job_data)
							}
							if(!this.applyData){
								this.applyData = obj
							}
						}
						
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}

				})
			},
			toPositionManagement() {
				let obj = {
					meetId: 3584,
					school_name: '万企线上招聘会',
					lat: '',
					lng: '',
					meeting_address: '',
					pdf_url: '',
					meeting_name: '万企线上招聘会',
					sign_up_img: '',
					sign_time: '7月10日 09:00-12:00',
					meeting_price: '',
					isBatch: false,
					isOther: true,
					isSpecial: true,
				}
				sessionStorage.setItem('meetObj', JSON.stringify(obj))
				this.$router.push({
					path: '/signup',
					query:{
						pathStaus:1,
					}
				})
			},
			toCorporateImage() {
				this.$router.push({
					path: '/corporateImage',
					query:{
						pathStaus:1,
					}
				})
			},
			elDialogClose2() {
				this.dialogVisible = false
			},
			openPDF() {
				window.open(
					'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/12/wanqiduijie.pdf',
					'_blank')
			},
			submit() {
				if (this.jobList.length>0) {
					if (this.isComplete) {
						this.$confirm('重新报名将会覆盖上次的报名信息，是否确定？', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning',
							})
							.then(() => {
								this.$util.post('v2/school_job/regSchoolMeeting', {...this.applyData, meeting_id: 3584}, (res) => {
									if (res.code === 200) {
										this.getCitysList()
										this.$message({
											message: '修改成功',
											type: 'success',
											duration: 1000
										})
										// this.dialogVisible = true
										setTimeout(() => {
											let is_demo = sessionStorage.getItem('demo')
											if(is_demo){
												this.$router.push({
													path: '/meeting?demo='+is_demo,
												})
											}else{
												this.$router.push({
													path: '/meeting',
												})
											}
										}, 1000)

									} else {
										this.$message({
											message: res.msg,
											type: 'error',
										})
									}

								})

							})
							.catch(() => {})
					} else {
						this.$util.post('v2/school_job/regSchoolMeeting', {...this.applyData, meeting_id: 3584}, (res) => {
							if (res.code === 200) {
								// this.getCitysList()
								this.$message({
									message: '报名成功',
									type: 'success',
									duration: 1000
								})
								setTimeout(() => {
									let is_demo = sessionStorage.getItem('demo')
									if(is_demo){
										this.$router.push({
											path: '/meeting?demo='+is_demo,
										})
									}else{
										this.$router.push({
											path: '/meeting',
										})
									}
								}, 1000)
								// this.dialogVisible = true
							} else {
								this.$message({
									message: res.msg,
									type: 'error',
								})
							}
						})
					}


				} else {
					this.$message({
						message: '请先发布岗位',
						type: 'error',
					})
				}
			},

			getCitysList() {
				// `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/dgsgbkjfkmzswgvs.json?${Math.random()}`
				this.$util.get1(
					`https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/dgsgbkjfkmzswgvs.json?${Math.random()}`, {},
					(res) => {
						if (res['mid_3584']) {
							this.qrcodeImg = res['mid_3584']
						} else {
							let province = ''
							res.provinces.forEach(item => {
								item.citys.forEach(i => {
									if (this.schoolInfo.company_name.indexOf(i.cityName) > -1 || this
										.schoolInfo.company_name.indexOf(item.provinceName) > -1) {
										province = item.provinceName
									}
								})
							})

							this.provinceImgList = res.qrcodeImgs
							if (this.provinceImgList[province]) {
								this.qrcodeImg = this.provinceImgList[province]
							} else {
								this.qrcodeImg =
									'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/wv4br98vawxpxkei.png'
							}
						}



					}
				)
			},
		},

	};
</script>
<style>
	/* #jobShadowing .el-picker-panel__footer /deep/ .el-button{
		display: none !important;
	} */
	#corporateApply .el-button--primary{
		background-color: #0284ff !important;
		border-color: #0284ff !important;
	}
	#corporateApply .btnContainer .el-button{
		padding: 10px 15px !important;;
	}
	
	#corporateApply .preview{
		color: #409EFF !important;
		background: #ffffff !important;
		border-color: #b3d8ff !important;
	}
	#corporateApply .cancel{
		color: #AEAEAE !important;
		background: #ffffff !important;
		border-color: #d0d0d0 !important;
	}
	#corporateApply .elDialog .el-dialog {
		background: initial;
		box-shadow: initial;
	}

	#corporateApply .avatar-uploader1 .el-upload {
		border: none !important;
	}

	#corporateApply .el-date-editor.el-input__inner {
		flex: 1 !important;
	}
</style>
<style lang="less" scoped>
	.closeContainer:hover .closeImg {
		display: inline-block;
	}

	.closeImg {
		display: none;
	}

	.container {
		width: 100%;
		padding: 0 40px;

		.companyInfo {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			font-size: 0;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			img {
				width: 57px;
				height: 57px;
				border-radius: 50%;
				margin-right: 10px;
			}

			.companyInfoRight {
				display: flex;
				justify-content: center;
				flex-direction: column;

				.companyInfoName {
					font-weight: 500;
					font-size: 18px;
					color: #2D3C50;
					margin-bottom: 10px;
				}

				.tags {
					display: flex;
					align-items: center;

					.item {
						padding: 2px 4px;
						border-radius: 5px;
						border: 1px solid #AEAEAE;
						font-weight: 500;
						font-size: 12px;
						color: #AEAEAE;
						margin-right: 5px;
					}
				}
			}
		}

		.companyInfoIpt {
			padding: 20px 0 0 0;

			.titleContainer {
				display: flex;
				align-items: center;
				margin-bottom: 30px;

				.shu {
					width: 2px;
					height: 13px;
					background: #1472FF;
					margin-right: 7px;
				}

				.title {
					font-weight: bold;
					font-size: 16px;
					color: #333333;
				}
			}

			.iptContainer {

				// .avatarContainer {
				// 	display: flex;
				// 	// align-items: center;
				// 	align-items: flex-start;
				// 	margin-bottom: 30px;

				// 	.text {
				// 		width: 100px;
				// 		display: flex;
				// 		align-items: center;
				// 		font-weight: 500;
				// 		font-size: 18px;
				// 		color: #333333;
				// 		margin-right: 20px;
				// 	}

				// 	.upload {
				// 		margin-right: 20px;
				// 	}

				// 	.uploadContainer {
				// 		display: flex;
				// 		align-items: center;

				// 		.uploadText {
				// 			width: 310px;
				// 			font-weight: 500;
				// 			font-size: 16px;
				// 			color: #999999;
				// 		}
				// 	}

				// }

				.ipt {
					width: 700px;
					display: flex;
					align-items: center;
					margin-bottom: 28px;

					.text {
						// width: 135px;
						width: 113px;
						display: flex;
						align-items: center;
						margin-right: 10px;
						display: flex;
						align-items: center;
						font-weight: 500;
						font-size: 14px;
						color: #000;
						justify-content: flex-end;

						span {
							font-weight: 500;
							font-size: 14px;
							color: #000;
						}
					}

					.el-input {
						flex: 1 !important;
					}

					.el-select {
						flex: 1 !important;
					}

					.el-textarea {
						flex: 1 !important;
					}
				}

			}

			.btnContainer {
				width: 700px;
				display: flex;
				justify-content: flex-end;
				margin-bottom: 60px;
				display: flex;
				align-items: center;
				// .el-button--primary {
				// 	background-color: #0084FF !important;
				// 	border-color: #0084FF !important;
				// 	// border-radius: 10px !important;
				// }
			}
		}


	}

	.companyContainer {
		display: flex;
		align-items: flex-start;
		width: 700px;

		.text {
			width: 113px;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-weight: 400;
			font-size: 14px;
			color: #000;
			margin-right: 10px;
		}

		.el-input {
			flex: 1 !important;
		}

		.company {
			flex: 1;
			background: #FFFFFF;
			border-radius: 5px;
			border: 1px solid #DCDFE6;
			box-sizing: border-box;
			padding: 15px 15px 20px 15px;

			.top {
				display: flex;
				align-items: center;
				width: 100%;
				border-bottom: 1px solid #dcdcdc69;
				margin-bottom: 20px;

				padding: 0 5px 15px 5px;

				.uplodadCompany1 {}

				.uplodadCompany {
					display: flex;
					align-items: center;
					font-size: 0;
					margin-left: 10px;

					img {
						width: 20px;
						height: 20px;
						margin-right: 12px;
					}

					.btn {
						font-weight: 500;
						font-size: 14px;
						color: #3A84E9;
					}
				}
			}

			.companyImg {
				display: flex;
				align-items: center;
				// padding: 0 15px;
				font-size: 0;

				img {
					width: 195px;
					height: 120px;
					margin-right: 15px;
				}

				div {
					font-weight: 500;
					font-size: 14px;
					color: #999;
					display: flex;
					// align-items: center;
					justify-content: space-between;
					flex-direction: column;
				}

			}
		}
	}

	.addNewContainer {
		width: 700px;
		display: flex;
		// align-items: flex-end;
		justify-content: flex-end;
		margin-bottom: 30px;

		.addNew {
			width: 600px;
			height: 60px;
			background: #f9fbff;
			border-radius: 5px;

			text-align: center;
			line-height: 60px;
			font-weight: 500;
			font-size: 14px;
			color: #3A84E9;
			cursor: pointer;
		}
	}

	.bg {
		width: 700px;
		height: 120px;
		background-image: url(../img/bg7.png);
		background-repeat: no-repeat;
		cursor: pointer;
		margin-bottom: 30px;
		box-sizing: border-box;
		padding: 30px 25px;
		border-radius: 10px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;

		.title {
			color: #119876;
			font-size: 20px;
			font-weight: bold;
			// margin-bottom: 10px;
		}

		.subheading {
			font-size: 0;
			display: flex;
			align-items: center;

			div {
				color: #606266;
				font-size: 14px;
				margin-right: 5px;
			}

			img {
				width: 15px;
				height: 15px;
			}
		}
	}

	.bg2 {
		width: 700px;
		height: 120px;
		background-image: url(../img/bg8.png);
		background-repeat: no-repeat;
		cursor: pointer;
		margin-bottom: 30px;
		box-sizing: border-box;
		padding: 30px 25px;
		border-radius: 10px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;

		.title {
			color: #119876;
			font-size: 20px;
			font-weight: bold;
			// margin-bottom: 10px;
		}

		.subheading {
			font-size: 0;
			display: flex;
			align-items: center;

			div {
				color: #606266;
				font-size: 14px;
				margin-right: 5px;
			}

			img {
				width: 10px;
				height: 10px;
			}
		}
	}

	.bg3 {
		width: 700px;
		height: 120px;
		background-image: url(../img/bg9.png);
		background-repeat: no-repeat;
		cursor: pointer;
		margin-bottom: 30px;
		box-sizing: border-box;
		padding: 30px 25px;
		border-radius: 10px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;

		.title {
			color: #119876;
			font-size: 20px;
			font-weight: bold;
			// margin-bottom: 10px;
		}

		.subheading {
			font-size: 0;
			display: flex;
			align-items: center;

			div {
				color: #606266;
				font-size: 14px;
				margin-right: 5px;
			}

			img {
				width: 10px;
				height: 10px;
			}
		}
	}

	.bg1 {
		width: 700px;
		height: 120px;
		background: #f7f8fc;
		// cursor: pointer;
		margin-bottom: 30px;
		box-sizing: border-box;
		padding: 20px 25px;
		border-radius: 10px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;

		.title {
			color: #119876;
			font-size: 20px;
			font-weight: bold;
			// margin-bottom: 10px;
		}

		.subheading {
			font-size: 0;
			display: flex;
			align-items: center;

			div {
				color: #606266;
				font-size: 14px;
				margin-right: 5px;
			}

			img {
				width: 10px;
				height: 10px;
			}
		}
	}




	#signup .changePassword {
		.elDialogContainer {

			.ipt {
				width: 100%;
				display: flex;
				align-items: center;
				margin-bottom: 20px;
				border: 1px solid #DCDFE6;
				border-radius: 4px;
				padding: 0 15px;

				.text {
					// width: 135px;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: 16px;
					color: #343232;
				}

				.el-input {
					flex: 1 !important;
				}

				.el-select {
					flex: 1 !important;
				}

				.el-textarea {
					flex: 1 !important;
				}
			}
		}
	}


	.previewElDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 50px 50px 50px;
			background: #FFFFFF;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 24px;
				color: #2A2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			padding: 50px 100px;
			// width: 410px;
			// height: 390px;
			background: #FFFFFF;
			border-radius: 10px;
			border: 4px solid #0084FF;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			.qrcodeImage { position: relative; width: 208px; height: 245px; }
			.qrcodeImg {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}
			.qrcodeLogo { position: absolute; top: 0; left: 0; right: 0; width: 90px; height: 90px; border-radius: 50%; margin: 58px auto; }

			.hite1 {
				font-weight: bold;
				font-size: 24px;
				color: #333333;
				margin-bottom: 17px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}
		}
	}
</style>

<style>
	/* #register .el-input__inner {
		font-size: 16px;
	} */

	.companyContainer .el-input__inner {
		border: none !important;
		padding: 0 !important;
	}

	.avatar-uploader .el-upload {
		border: 1px solid #E5E5E5;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #F5F7FA;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatarUploader {
		width: 80px;
		height: 80px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.avatar-uploader-icon {
		font-size: 14px;
		color: #8c939d;
		margin-bottom: 5px;
	}

	.avatar-uploader span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}



	.environment {
		border: 1px solid #DCDFE6;
		flex: 1;
		background-color: #FFF;
		color: #606266;
		height: 40px;
		padding: 0 15px;
		border-radius: 4px;
		font-size: 14px;
		line-height: 40px;
		cursor: text;

		overflow: hidden;

		text-overflow: ellipsis;

		white-space: nowrap;
		width: 500px;
	}
</style>
